module.exports = __webpack_public_path__ + "img/modern-farmhouse.3179121.jpg";